




















import { defineComponent, PropType, ref, onMounted, onBeforeUnmount } from '@vue/composition-api'
import { IParagraph } from '../../models/paragraph'

import scrollDirective from '@/shared/directives/scroll-directive'
import { bottomIsInParent } from '@/shared/filters/utils-filter'

import CloseButtonAtom from '@/shared/components/atoms/CloseButtonAtom.vue'
import RichTextAtom from '@/shared/components/atoms/RichTextAtom.vue'

declare global {
    interface Window {
        dataLayer: any[]
    }
}

export default defineComponent({
    name: "ContentComponent",
    components: {
        CloseButtonAtom,
        RichTextAtom
    },
    directives: {
        scrollDirective
    },
    props: {
        content: {
            type: Array as PropType<IParagraph[]>,
            required: true
        },
        title: {
            type: String,
            required: false,
            default: ''
        }
    },
    setup: (props) => {
        const contentElement = ref<HTMLElement | null>(null)
        const paragraphs = props.content?.map(x => x.html) || []

        const handleLinkClick = (event: MouseEvent) => {
            const target = event.target as HTMLElement
            if (!target || target.tagName.toLowerCase() !== 'a') return

            const linkEl = target as HTMLAnchorElement
            const clickUrl = linkEl.href
            const clickText = linkEl.textContent?.trim() || ''
            const title = props.title

            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
                event: "slider_click",
                block_title: title,
                click_url: clickUrl,
                click_text: clickText
            })
        }

        onMounted(() => {
            if (contentElement.value) {
                contentElement.value.addEventListener('click', handleLinkClick)
            }
        })

        onBeforeUnmount(() => {
            if (contentElement.value) {
                contentElement.value.removeEventListener('click', handleLinkClick)
            }
        })

        const showScrollIndicator: boolean = contentElement.value?.lastElementChild
            ? !bottomIsInParent(contentElement.value.lastElementChild)
            : false

        return {
            contentElement,
            paragraphs,
            showScrollIndicator
        }
    }
})
